module.exports = __webpack_public_path__ + "img/4.f2e706b9.png";